export enum HomePageMode {
  NO_PERMISSION = 'no-permission',
  ASSET_NOT_FOUND = 'asset-not-found',
  PAGE_NOT_FOUND = 'page-not-found',
  ASSET_PROFILE_BLANK = 'asset-profile-blank'
}